import moment from 'moment'
import getFormattedOffset from '../utils/format-date-timezone-offset'

export default class EventHistory {
  constructor(
    zoneId = -1,
    eventId = -1,
    eventDescription = '',
    comment = '',
    eventDate = ''
  ) {
    this.zoneId = zoneId
    this.eventId = eventId
    this.eventDescription = eventDescription
    this.comment = comment
    this.eventDate = eventDate
  }

  mapFromApi(responseData, timeZoneInfo) {
    this.zoneId = responseData.ZoneId
    this.eventId = responseData.EventId
    this.eventDescription = responseData.EventDescr
    this.comment = responseData.Comment
    if (responseData.EventDate) {
      this.eventDate = moment(
        responseData.EventDate + getFormattedOffset(timeZoneInfo)
      ).utc()
    }
  }
}
